/* @HEADER
 * @version 1.0.1618 | 2026-09-20
 * @purpose The route-level lazy chunks (ZVX-DEV-2261, ZVX-DEV-2938): the analytics screen and the #account cabinet load on demand and must render inside Suspense. A component-only module so the route table and the screen renderer can share them under the fast-refresh rule (ZVX-DEV-6136).
 * @sidecar lazyScreens.tsx.header.md
 * @layer app | @hex adapter | @ctx app
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-6136, ZVX-DEV-2261, ZVX-DEV-2938

import { lazy } from 'react'

export const AnalyticsPage = lazy(() => import('../features/kanban/public-api').then((m) => ({ default: m.AnalyticsPage })))
export const AccountPage = lazy(() => import('../features/account/public-api').then((m) => ({ default: m.AccountPage })))
